module.exports = __webpack_public_path__ + "img/hyper_extract.345be735.jpg";